import React from 'react';
import './Header.scss';


function Header() {
  return (
    <div className="Header">
        <h2>Weather App</h2>
        <p>Helps you to find the weather</p>
    </div>
  )
}

export default Header;
